import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getCompaniesCidPersons} = api.companies;

const getCompaniesCidPersonsRefresh = atom<number>({
  key: 'getCompaniesCidPersonsRefresh',
  default: 0,
});

const getCompaniesCidPersonsQuery = selectorFamily({
  key: 'getCompaniesCidPersons',
  get(params: Parameters<typeof getCompaniesCidPersons>[0]) {
    return async ({get}) => {
      get(getCompaniesCidPersonsRefresh);
      try {
        const {data} = await getCompaniesCidPersons(params);
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        return null;
      }
    };
  },
});

export const useGetCompaniesCidPersonsQuery = createQuery(getCompaniesCidPersonsQuery, getCompaniesCidPersonsRefresh);
